module.exports = __webpack_public_path__ + "static/Portrait-of-Axel-min-87261b9ed67542efa4707e2fcba79f30.webp";